import { FunctionalComponent, h } from '@stencil/core';
import { FundData } from '../../_interfaces/fund-card/fund-data';
import { setFundAttributes, addDotsToAcronym } from './_helpers';

interface HeaderProps {
	domicileType: string;
	data: FundData;
}

export const Header = ({
	domicileType,
	data,
}): FunctionalComponent<HeaderProps> => {
	const { fundUrl, dataLinkEvent, fundheader, keyfundfacts, fundType } = data;
	const useOfProfits = keyfundfacts?.useOfProfitsCode?.formattedValue;
	const assetClass = fundheader?.fundName?.assetClass?.formattedValue;
	const fundName = fundheader?.fundName?.fundName?.formattedValue;
	const fundCurrencyCode = fundheader?.fundNav?.navAmount?.prefix;
	const shareClass = fundheader?.fundNav?.investorClass?.formattedValue;
	const isActive = fundheader?.fundName?.activeBadge?.value;
	const labelActive = data.contentTranslations.upperCaseActive;

	let ticker, tickerAriaLabel;
	if (fundheader?.fundTicker?.ticker?.formattedValue) {
		ticker = fundheader?.fundTicker?.ticker?.formattedValue;
		// Add dots to acronym so that screen readers read letters instead of words (the full stops are not read out)
		tickerAriaLabel = addDotsToAcronym(ticker);
	} else {
		// For some sites the ticker wasn't showing, so you can get it from here instead (eg. HK)
		// In this scenario, the ticker is a different kind of format, eg. '2823 / 82823'
		// so we wouldn't want to use addDotsToAcronym() for the ARIA label is it would become "2.8.2.3. ./. .8.2.8.2.3."
		ticker = fundheader?.fundTicker?.listingTicker?.formattedValue;
		tickerAriaLabel = ticker;
	}

	const attributes = setFundAttributes(
		fundCurrencyCode,
		shareClass,
		useOfProfits
	);
	return (
		<div class="ds-card-container ds-card-header-container">
			<a href={fundUrl} data-link-event={dataLinkEvent}>
				<p class="ds-eyebrow-l ds-asset-class" aria-label={assetClass}>
					{assetClass}
				</p>
				<p class="ds-heading-s-lc ds-fund-name" aria-label={fundName}>
					<span>{fundName}</span>
				</p>

				{fundType === 'index' ? (
					<p class="ds-body-xs-compact-bold ds-fund-attributes">{attributes}</p>
				) : null}

				{fundType === 'etf' ? (
					<p class="d-flex align-items-center ds-fund-attributes">
						<span
							class="ds-ticker ds-body-s-compact-bold"
							aria-label={tickerAriaLabel}
						>
							{ticker}
						</span>

						{isActive ? (
							<span class="ds-body-s-compact-bold ds-active-etf">
								{labelActive}
							</span>
						) : null}

						{domicileType === 'emea' ? (
							<span class="ds-body-xs-compact-bold ds-space-xs-left ds-space-xxxs-top">
								{attributes}
							</span>
						) : null}
					</p>
				) : null}
			</a>
		</div>
	);
};
